import { rawModules } from "./listConstants";

export const SERVER = process.env.REACT_APP_BACKEND_ENDPOINT;
export const NEW_ITEM_ID = 0

export const MANUAL_API_ENDPOINTS = {
    AITREE: {
        CHATS: '/chats/',
        API_ASSIGNMENTS_FOR_STAGE: (stageId) => `/aitrees/api_assignments_for_stage/${stageId}`,
        PROMPT_FOR_STAGE: (stageId) => `/aitrees/prompts/${stageId}`,
        STAGE_CONNECT: (chatId) => `/aitrees/stage_connect/${chatId}`,
        STAGES: (chatId) => `/aitrees/stages/${chatId}`,
        IMPORT: (chatId) => `/aitrees/import/${chatId}`
    },
    APPS: {
        LIST: '/apps/',
    },
    AVATARS: {
        ACTIVE: '/avatars/avatars/active',
    },  
    CHATS: {
        CHAT_PARAMS: (chatId) => `/chats/${chatId}/params`,
        CONDITION_OPTIONS: (chatId) => `/chats/${chatId}/conditions`,
        MEDIA: (chatId) => `/chats/${chatId}/medias`,
    },
    COMMUNICATION_PLANS: {
        STEPS: (id) => `/communication-plans/${id}/steps`,
    }, 
    CUSTOMERS: {
        CATEGORIES: '/customer/categories',
        ADDRESSES: (customerId) => `/customer/${customerId}/addresses`,
        EMAIL_ADDRESSES: (customerId) => `/customer/${customerId}/email_addresses`,
        PHONE_NUMBER: (customerId) => `/customer/${customerId}/phone_numbers`,
        INTERACTIONS: (customerId) => `/customer/${customerId}/interactions`,
        COMPANY_RELATION: (customerId) => `/customer/${customerId}/company_relation`,
        AI_FILL: (customerId) => `/customer/${customerId}/ai/fill`,
        AI_SUMMARY: (customerId) => `/customer/${customerId}/ai/summary`,
        AI_SUGGESTIONS: (customerId) => `/customer/${customerId}/ai/suggestions`,
        AI_REVISE: (customerId) => `/customer/${customerId}/ai/revise`,
        METRICS: (customerId) => `/customer/${customerId}/metrics`,
    },
    EMAILS: {
        ATTACHMENTS: (emailId, uploadId) => `/email/${emailId}/attachment/${uploadId}`,
        SEND: (id) => `/email/${id}/send`,
    },
    ACCOUNT_SETTINGS: {
        LINKEDIN_REFRESH: (accountSettingsId) => `/linkedin/${accountSettingsId}/linkedin/refresh`,
        LINKEDIN_AUTH: (accountSettingsId) => `/linkedin/${accountSettingsId}/linkedin/start_linkedin_auth`,
        LINKEDIN_DELETE: (accountSettingsId) => `/linkedin/${accountSettingsId}/linkedin/delete_linkedin_auth`,
        DEFAULT: `/account-settings/default`,
    },
    EVENTS: {
        TRIGGER: (id, action) => `/events/${id}/actions/${action}`,
        FILTER_TREE: (id) => `/events/${id}/filter_tree`,
        EXECUTE_FILTER_TREE: (id) => `/events/${id}/filter_tree/execute`,
    },
    SCHEDULERS: {
        RECALCULATE: (id) => `/schedulers/${id}/recalculate`,
    },
    INTEGRATIONS: {
        EXECUTE_API: (id) => `/integrations/${id}/trigger`,
    },
    KNOWLEDGE: {
        PROCESS: (id) => `/knowledges/${id}/process`
    },
    METADATA: {
        OBJ: (obj) => `/metadata/obj/${obj}`,
    },
    ORDERS: {
        LINE_ITEMS: (id) => `/orders/${id}/line_items`,
    },
    PRODUCTS: {
        CROSS_SELL: (id) => `/products/${id}/cross_sell`,
    },
    REPORTS: {
        AI_USAGE: '/reports/token_usage',
        EMAILS: '/reports/emails',
        COMPANIES: '/reports/companies',
        ELEVENLABS: '/reports/elevenlabs',
    },
    SETTINGS: {
        USER_SETTINGS: '/api/data/user_settings'
    },
    TENANTS: {
        CURRENT: '/tenants/current',
    },
    UPLOADS: {
        CATEGORIES: '/uploads/categories',
        FILE: (file_name) => `/uploads/files/${file_name}`,
        DOWNLOAD: (id) => `/uploads/files/id/${id}`,
        ANALYZE: (uploadId) => `/uploads/${uploadId}/analyze`,
        FILE_UPLOAD: (uploadId) => `/uploads/file_upload/${uploadId}`,
        IMPORT_DATA: (uploadId) => `/uploads/${uploadId}/imports`
    },
    ROLES: {
        PERMISSIONS: (roleId) => `/roles/${roleId}/permissions`,
        PERMISSIONS_SHORTCUT: (roleId) => `/roles/${roleId}/permissions/shortcut`
    },
    USERS: {
        USER_ROLES: (TenantUserId) => `/users/${TenantUserId}/roles`,
        TENANT_USER: (tenantUserId) => `/users/tenant/${tenantUserId}`,
        ID: '/users/user',
        INVITATIONS: '/users/invitations',
        VALIDATE_INVITATION: '/users/validate-invitation',
        ACCEPT_INVITATION: '/users/accept-invitation',
        ADDRESSES: (id) => `/users/${id}/addresses`,
        SELECT_TENANT: (tenantId) => `/users/select_tenant/${tenantId}`,
    }
};

export const generatedApiEndpoints = Object.fromEntries(
        rawModules.filter(mod => mod.route !== null).map(({ key, route }) => {
            const KEY = key.toUpperCase()
            const manual = MANUAL_API_ENDPOINTS[KEY] || {}; 
            return [
                KEY,
                {
                    ITEM: manual.ITEM || ((id) => `${route}${id}`),
                    LIST: manual.LIST || `${route}`,
                    SYNC: manual.SYNC || `${route}sync`,
                    SEARCH: manual.SEARCH || `${route}search`,
                    ...manual,
                },
            ];
        })
);

export const API_ENDPOINTS = {
    ...MANUAL_API_ENDPOINTS,
    ...generatedApiEndpoints,
};